module.exports = __webpack_public_path__ + "img/album04_04.521bb92a.jpg";